import React,{useState} from "react";
import "../../components/StateList/StateList.css";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
// import axios from "axios";

const StateList = ({stateDetailResponse, setOpenProfile, openProfile,GetId,setOpenAddProfile
}) => {
    
    function HandleChange(param) {
    
      GetId(param);
    }
    const itemsPerPage = 50;
  const [currentPage, setCurrentPage] = useState(1);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  // Add a null check using the optional chaining operator (?.)
  const visibleData = stateDetailResponse?.slice(startIndex, endIndex);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  return (
    <div className="container-fluid">
      
      <div className="stateList">
        <table>
          <tr className="stateListHeading">
            <th>S No.</th>
            <th>Country Name</th>
            <th>State Name</th>
            <th>Action</th>
          </tr>
          {visibleData !== null && visibleData?.length > 0 ? (
            visibleData.map((state) => (
        <tr key={state.state_id}>
            <td>{state.state_id}</td>
            <td>{state.countryname}</td>
            <td>{state.stateName}</td>
            <td>
                <button style={{ height: "35px", width: "35px", backgroundColor: "#F1F1F1"}} 
                onClick={() => {setOpenProfile(!openProfile);
                  HandleChange(state.state_id); 
                      setOpenAddProfile(false);}}>
                    <EditOutlinedIcon className="icon" />
                </button>
                <button style={{ height: "35px", width: "35px", marginLeft: "5px", backgroundColor: "#F4616F", borderColor: "#FF0000"}} >
                    <DeleteOutlinedIcon className="icon" />
                </button>
            </td>
        </tr>
    ))
) : (
    <p>empty</p>
)}         
          
        </table>
        <nav
          aria-label="Page navigation"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "1rem",
          }}
        >
          <ul className="pagination">
            <li className="page-item">
              <a
                className="page-link"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </a>
            </li>
            <li className="page-item">
              <a
                className="page-link"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                {currentPage - 1}
              </a>
            </li>
            <li className="page-item active">
              <a className="page-link">{currentPage}</a>
            </li>
            <li className="page-item">
              <a
                className="page-link"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={endIndex >= stateDetailResponse?.length}
              >
                {currentPage + 1}
              </a>
            </li>
            <li className="page-item">
              <a
                className="page-link"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={endIndex >= stateDetailResponse?.length}
              >
                Next
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default StateList;
